export const AUX_FIELDS_BY_SECOND_DIMENSION: Record<
  string,
  { key: string; values: string[] }
> = {
  'user.id': {
    key: 'user',
    values: ['user.firstName', 'user.lastName'],
  },
  'location.id': {
    key: 'location',
    values: ['location.name'],
  },
  'trigger.id': {
    key: 'trigger',
    values: ['trigger.name'],
  },
};
